import React, { useEffect, useRef, useLayoutEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { getRegionBySlug } from "./constants";

const EmergencyAnnouncements = ({
  onEmergencyUpdate,
  slug,
  onHeightChange,
}) => {
  const ref = useRef(null); // needed to measure the height of this div

  const data = useStaticQuery(graphql`
    query {
      allContentfulAnnouncements {
        edges {
          node {
            announcement {
              announcement
            }
            region
          }
        }
      }
    }
  `);

  const filteredAnnouncements = (announcementsUnfiltered) => {
    let res = [];
    let isNorth = getRegionBySlug(slug) == "north";
    announcementsUnfiltered.forEach((element) => {
      if (element.node.region == "global") {
        res.push(element.node.announcement.announcement);
      } else if (element.node.region == "north" && isNorth) {
        res.push(element.node.announcement.announcement);
      } else if (element.node.region == "south" && !isNorth) {
        res.push(element.node.announcement.announcement);
      }
    });
    return res;
  };

  const announcements = filteredAnnouncements(
    data.allContentfulAnnouncements.edges,
  );

  useEffect(() => {
    const isEmergency = announcements.length > 0 && announcements != null;
    onEmergencyUpdate(isEmergency);
  }, [announcements]);

  useLayoutEffect(() => {
    // Get the height of the component and pass it to the parent
    if (ref.current) {
      const height = ref.current.offsetHeight;
      onHeightChange(height);
    }
  }, [announcements]);

  return (
    <div
      ref={ref}
      className="emergency-announcements"
      style={{
        background: "#EF6C49",
        color: "#0a0a0a",
        textAlign: "center",
        minHeight: "39px",
      }}
    >
      <p
        style={{
          textAlign: "center",
          fontSize: "0.9em",
          position: "relative",
          top: "3px",
        }}
      >
        {announcements &&
          announcements.map((announcement, index) => (
            <span key={index} style={{ marginLeft: "10px" }}>
              {announcement}
            </span>
          ))}
      </p>
    </div>
  );
};

export default EmergencyAnnouncements;
